import type { DesignTokens } from '@/handshake/protocol.js';

/** Radius presets, mirroring the Kadanza DAM widget so corners scale identically. */
const BORDER_RADIUS_MAP: Record<string, string> = {
  sm: '0.25rem',
  md: '0.5rem',
  lg: '0.75rem',
  xl: '1rem',
};

const APPLIED_VARS = ['--brand-primary', '--brand-font', '--brand-radius'] as const;

export function applyDesignTokens(tokens: DesignTokens): void {
  const root = document.documentElement;

  if (tokens.primaryColor) root.style.setProperty('--brand-primary', tokens.primaryColor);
  if (tokens.fontFamily) root.style.setProperty('--brand-font', `"${tokens.fontFamily}"`);

  const radius = BORDER_RADIUS_MAP[tokens.borderRadius];
  if (radius) root.style.setProperty('--brand-radius', radius);
}

export function clearDesignTokens(): void {
  const root = document.documentElement;
  for (const name of APPLIED_VARS) root.style.removeProperty(name);
}
